import React from "react";
import { AttrTypeName } from "src/types/AttrType";
import {
  CopyByValueStore,
  ParamsCopyByValueStore,
} from "./CopyByValueEditStore";
import {
  DictSingleAttrCopyProps,
  filedNamesDictSingleAttrCopy,
} from "./CopyByValueForm/attributeDependent/DictSingleAttrCopySettings";
import { copyByValueFieldNames } from "./CopyByValueForm/CopyByValueForm";

export const createCopyByValueEditStore = (params: ParamsCopyByValueStore) => {
  const store = new CopyByValueStore(params);
  const typeName = params.typesMap[params.valueType];
  switch (typeName) {
    case AttrTypeName.dictSingle: {
      store.setTypeDependentSettings([
        {
          key: "dictSingle",
          onFormChange(changed, form) {
            if (copyByValueFieldNames.parentAttributeId in changed) {
              form.resetFields([
                filedNamesDictSingleAttrCopy.withRestrictions,
                filedNamesDictSingleAttrCopy.groupIdsToCopy,
              ]);
            }
          },
          render(props) {
            return (
              <DictSingleAttrCopyProps
                curCopySrcAttrId={props.curCopySrcAttrId}
                curLinkAttrId={props.curLinkAttrId}
                avaliableCopyAttrData={props.avaliableCopyAttrData}
              />
            );
          },
        },
      ]);
      break;
    }

    default:
      break;
  }

  return store;
};
